import { useCallback, useRef } from 'react';
import isDefaultStringRecordExport from '../../../is/is-default-string-record-export.js';
import isStringRecord from '../../../is/is-string-record.js';
const DEFAULT_IS_FETCHED = Object.freeze({});
export default function useLoadTranslations({ onLoad, onLoadError, translationsRecord }) {
    const isFetchedRef = useRef(DEFAULT_IS_FETCHED);
    return useCallback((locale) => {
        if (isFetchedRef.current[locale] === true) {
            return null;
        }
        isFetchedRef.current = {
            ...isFetchedRef.current,
            [locale]: true,
        };
        const translations = translationsRecord[locale];
        if (typeof translations === 'undefined') {
            throw new Error(`Locale not found: ${String(locale)}`);
        }
        if (isStringRecord(translations)) {
            onLoad(locale, translations);
            return null;
        }
        if (isDefaultStringRecordExport(translations)) {
            onLoad(locale, translations.default);
            return null;
        }
        const importedRecord = translations();
        if (isStringRecord(importedRecord)) {
            onLoad(locale, importedRecord);
            return null;
        }
        if (isDefaultStringRecordExport(importedRecord)) {
            onLoad(locale, importedRecord.default);
            return null;
        }
        return importedRecord
            .then((record) => {
            if (isDefaultStringRecordExport(record)) {
                onLoad(locale, record.default);
                return;
            }
            onLoad(locale, record);
        })
            .catch((err) => {
            if (typeof onLoadError === 'undefined') {
                throw err;
            }
            onLoadError(locale, err);
        });
    }, [onLoad, onLoadError, translationsRecord]);
}
//# sourceMappingURL=use-load-translations.js.map